import { CompleteDeliveryState } from './completeDelivery.types'

const completeDeliveryInitialState: CompleteDeliveryState = {
  loading: false,
  error: null,
  success: null
}

export default completeDeliveryInitialState
